import React from 'react';
import { motion } from 'framer-motion';

const VennDiagram = () => {
  return (
    <div className="w-full h-full">
      <svg viewBox="0 0 600 560" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
        <defs>
          <style>
            {`
              .venn-text-title { 
                font-family: 'Crimson Pro', serif; 
                font-size: 18px; 
                font-weight: 700; 
                fill: #F7F5F2; 
                text-anchor: middle;
              }
              .venn-text-item { 
                font-family: 'JetBrains Mono', monospace; 
                font-size: 11px; 
                fill: rgba(255,255,255,0.7); 
                text-anchor: middle;
              }
              .venn-circle { 
                mix-blend-mode: screen; 
                transition: all 0.4s ease;
                cursor: pointer;
              }
              .venn-circle:hover {
                opacity: 1;
                filter: brightness(1.2);
              }
              .center-highlight {
                animation: pulse 4s infinite ease-in-out;
              }
              @keyframes pulse {
                0% { opacity: 0.1; r: 25; }
                50% { opacity: 0.3; r: 30; }
                100% { opacity: 0.1; r: 25; }
              }
            `}
          </style>
        </defs>
        
        {/* Circle 1: Computational & Modeling (Top-Left) */}
        <motion.g 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            viewport={{ once: true }}
        >
            <circle className="venn-circle" cx="200" cy="180" r="160" fill="#134E4A" opacity="0.7" stroke="#2DD4BF" strokeWidth="1" strokeOpacity="0.2"/>
            <text className="venn-text-title" x="140" y="130">Computational</text>
            <text className="venn-text-title" x="140" y="150">& Modeling</text>
            
            <text className="venn-text-item" x="140" y="180">Network Analysis</text>
            <text className="venn-text-item" x="140" y="195">Monte Carlo Uncertainty</text>
            <text className="venn-text-item" x="140" y="210">Bayesian Inference</text>
            <text className="venn-text-item" x="140" y="225">Graph-RAG Arch.</text>
        </motion.g>
        
        {/* Circle 2: Biological & Ecological (Top-Right) */}
        <motion.g 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
        >
            <circle className="venn-circle" cx="400" cy="180" r="160" fill="#12402B" opacity="0.7" stroke="#2DD4BF" strokeWidth="1" strokeOpacity="0.2"/>
            <text className="venn-text-title" x="460" y="130">Biological</text>
            <text className="venn-text-title" x="460" y="150">& Ecological</text>
            
            <text className="venn-text-item" x="460" y="180">Trophic Dynamics</text>
            <text className="venn-text-item" x="460" y="195">Population Ecology</text>
            <text className="venn-text-item" x="460" y="210">Metagenomics</text>
            <text className="venn-text-item" x="460" y="225">Resilience Modeling</text>
        </motion.g>
        
        {/* Circle 3: Financial & Economic (Bottom-Center) */}
        <motion.g 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            viewport={{ once: true }}
        >
            <circle className="venn-circle" cx="300" cy="370" r="160" fill="#1A3263" opacity="0.7" stroke="#2DD4BF" strokeWidth="1" strokeOpacity="0.2"/>
            <text className="venn-text-title" x="300" y="390">Financial</text>
            <text className="venn-text-title" x="300" y="410">& Economic</text>
            
            <text className="venn-text-item" x="300" y="435">Natural Capital Acct.</text>
            <text className="venn-text-item" x="300" y="450">MRV Architecture</text>
            <text className="venn-text-item" x="300" y="465">Blue Bond Covenants</text>
            <text className="venn-text-item" x="300" y="480">Credit Risk Translation</text>
        </motion.g>
        
        {/* Center Intersection */}
        <motion.circle 
            className="center-highlight" 
            cx="300" 
            cy="255" 
            r="25" 
            fill="#2DD4BF" 
            opacity="0.2"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 0.2 }}
            transition={{ delay: 1 }}
        />
        
        {/* Optional: Center icon or symbol */}
        <motion.text 
            x="300" 
            y="260" 
            textAnchor="middle" 
            fill="#2DD4BF" 
            fontSize="14" 
            fontWeight="bold"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 1.2 }}
        >
            ◆
        </motion.text>

      </svg>
    </div>
  );
};

export default VennDiagram;
